import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerNavModule } from './extensions/a6d7fb93a3201aab94d0e39580f7c1ea280a17a0e14443b4d81bdb68f5a83a90/banner-nav.module';
import { CompleteOrderButtonModule } from './extensions/3384388b202f74eab7c2868b463e157bff67f3c0ad6e936f80521c1ce88fe634/complete-order-button.module';
import { CancelOrderButtonModule } from './extensions/5de37f7c6e1fa2b3fdacb102c66d3d517b19a97039860c30a47c4a74d163e89e/cancel-order-button.module';
import { MetricsWidgetSharedModule } from './extensions/9bd954a132d71ee03bdc619efa0d862055392d19b16c574671026ac72031b877/metrics-widget.shared-module';
import { LocaleModule } from './extensions/f5633f1fdccad35cf8536ce57ad2f7ab4737813470f34150024999ac11f97948/locale-module';

import SharedProviders_5_0 from './extensions/refund-custom/providers';


@NgModule({
    imports: [CommonModule, BannerNavModule, CompleteOrderButtonModule, CancelOrderButtonModule, MetricsWidgetSharedModule, LocaleModule],
    providers: [...SharedProviders_5_0],
})
export class SharedExtensionsModule {}
